import { GatewayService } from '../GatewayService'
import { FormularioTraderModel } from '../model/FormularioTraderModel'

export class FormularioTraderProvider {
    estruturaFormulario() {
        return new GatewayService().requestGet('/api/formularios')
    }

    enviaFormulario(data: FormularioTraderModel) {
        return new GatewayService().requestPost('/api/formularioRespostas', data)
    }

    // Deverá me retornar se o formulário já possui resultado ou não
    resultado() {
        return new GatewayService().requestGet('/api/formularios/resultadoPesquisa')
    }

    respostas() {
        return new GatewayService().requestGet('/api/formularios/respostas')
    }
}